import { InsightProofIconButton } from '@modules/oracle/components/InsightProofIconButton';
import { useFeedbackSummaryStore } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryStore';
import { ExtraProps } from 'react-markdown';
import { createAnalyticsTracker } from 'v2/analytics/events';

const trackFeedbackListSummaryEvents = createAnalyticsTracker(
  'feedbackListSummary',
);

type FeedbackProofIconButtonProps = React.ClassAttributes<HTMLElement> &
  React.HTMLAttributes<HTMLElement> &
  ExtraProps & {
    openCitedArtefactsInNewTab?: boolean;
    isFeedbackSidebarView?: boolean;
  };

export function FeedbackProofIconButton({
  node,
  children,
  openCitedArtefactsInNewTab,
  isFeedbackSidebarView,
}: FeedbackProofIconButtonProps) {
  const messages = useFeedbackSummaryStore(({ data }) => data.messages);
  const userQuotesByExampleID = useFeedbackSummaryStore(
    ({ data }) => data.userQuotesByExampleID,
  );

  const userQuoteTokensByResponseID = useFeedbackSummaryStore(
    ({ data }) => data.userQuoteTokensByResponseID,
  );
  const sessionID = messages[0]?.sessionID;

  //TODO: Remove this after Chat with Feedback is enabled
  const exampleID = node?.properties?.['id']
    ? String(node?.properties?.['id'])
    : undefined;

  const artefactID = node?.properties?.['id']
    ? String(node?.properties?.['id'])
    : undefined;

  const feedbackSummaryToken = exampleID
    ? messages.find(
        (message) =>
          message?.feedbackSummary?.token?.details?.examples?.id === exampleID,
      )?.feedbackSummary?.token
    : undefined;

  const artefactToken = artefactID
    ? messages.find(
        (message) =>
          message?.feedbackSummary?.token?.details?.artefact?.artefactID ===
          artefactID,
      )?.feedbackSummary?.token?.details
    : undefined;

  const feedbackSummaryExample = feedbackSummaryToken?.details?.examples;
  const label = feedbackSummaryExample?.labelExample?.forLabel;

  const onClick = (isOpen: boolean) => {
    trackFeedbackListSummaryEvents({
      eventName: isOpen
        ? 'Feedback List Summary - User Quote Closed'
        : 'Feedback List Summary - User Quote Opened',
    });
  };

  return (
    <InsightProofIconButton
      feedbackSummaryExample={feedbackSummaryExample}
      userQuoteTokensByResponseID={userQuoteTokensByResponseID}
      userQuotesByExampleID={userQuotesByExampleID}
      sessionID={sessionID}
      label={label}
      children={children}
      onClick={onClick}
      artefact={artefactToken?.artefact}
      openCitedArtefactsInNewTab={openCitedArtefactsInNewTab}
      isFeedbackSidebarView={isFeedbackSidebarView}
    />
  );
}
